import { render } from "./FooterSection.vue?vue&type=template&id=fe4ebe0c&scoped=true"
const script = {}

import "./FooterSection.vue?vue&type=style&index=0&id=fe4ebe0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4ebe0c"]])

export default __exports__